import {
  GET_CONCRETE_BATCHES_REQUEST,
  DELETE_CONCRETE_BATCH_REQUEST,
  CREATE_CONCRETE_BATCH_REQUEST,
} from './types';

const getConcreteBatches = (payload) => ({
  type: GET_CONCRETE_BATCHES_REQUEST,
  payload,
});

const deleteConcreteBatch = (payload) => ({
  type: DELETE_CONCRETE_BATCH_REQUEST,
  payload,
});

const createConcreteBatch = (payload) => ({
  type: CREATE_CONCRETE_BATCH_REQUEST,
  payload,
});

export { getConcreteBatches, deleteConcreteBatch, createConcreteBatch };
